var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0003 26.5865C33.1222 26.5357 33.243 26.4829 33.3628 26.4282C34.0267 26.125 34.7714 26.0116 35.4765 26.2002L36.3492 26.4337C38.1208 26.9078 39.7416 25.287 39.2676 23.5154L39.034 22.6426C38.8454 21.9376 38.9588 21.1928 39.262 20.529C39.9502 19.0225 40.3337 17.3476 40.3337 15.5832C40.3337 13.2474 39.6616 11.0685 38.5003 9.22941M17.417 10.9918C19.2148 6.68965 23.4628 3.6665 28.417 3.6665C30.7795 3.6665 32.9814 4.354 34.8337 5.53984",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 12.9621C23.5094 11.7142 21.0048 11 18.3333 11C10.2332 11 3.66667 17.5665 3.66667 25.6667C3.66667 28.0129 4.21757 30.2304 5.19708 32.197C5.45737 32.7196 5.54401 33.3169 5.39311 33.8809L4.51955 37.1458C4.14033 38.563 5.43695 39.8597 6.85424 39.4804L10.1191 38.6069C10.6831 38.456 11.2804 38.5426 11.803 38.8029C13.7696 39.7824 15.9871 40.3333 18.3333 40.3333C26.4335 40.3333 33 33.7668 33 25.6667C33 22.9952 32.2858 20.4906 31.0379 18.3333",
    stroke: "#004945",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9506 25.6665H11.9671M18.3502 25.6665H18.3667M24.7504 25.6665H24.7669",
    stroke: "#0B847E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/Dialog.c0edc7abdb27fb3f8a84f83aa5bc9175.svg";
export { ForwardRef as ReactComponent };